import React, { useRef, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const SignatureModal = ({ visible, onHide, onSave }) => {
    const sigCanvas = useRef({});
    const [signatureImage, setSignatureImage] = useState(null);

    const save = () => {
        const dataURL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
        setSignatureImage(dataURL);
        onSave(dataURL); // Call the onSave function passed as a prop
        onHide(); // Close the modal
    };

    const clear = () => {
        sigCanvas.current.clear();
    };

    return (
        <Dialog header="Draw Your Signature" visible={visible} onHide={onHide}>
            <div className='p-2'>
                <div className='
                boder1'>
                    <SignaturePad
                        ref={sigCanvas}
                        canvasProps={{
                            className: "signatureCanvas",
                            width: 400,
                            height: 200,
                        }}
                    />
                </div>
                <div className="flex justify-content-end mt-2 gap-2">
                    <Button className='p-2 copySave-button' label="Clear" onClick={clear} />
                    {/* <Button className='p-2 copySave-button' label="Close" onClick={onHide} /> */}
                    <Button className='p-2 customSave-button' label="Save" onClick={save} />
                </div>
                {signatureImage && (
                    <div className="mt-2 ">
                        <div className='bg-gray-800 text-yellow-500 py-2 px-4'>
                            <h5 className='text-center'>Your Signature:</h5>
                        </div>
                        <div className='boder1' >
                            <img src={signatureImage} alt="Signature" style={{ width: '100%', height: 'auto' }} />
                        </div>
                    </div>
                )}
            </div>
        </Dialog>
    );
};

export default SignatureModal;